import React, { useContext } from "react";
import AudioPlayer from "react-h5-audio-player";
import { Songs } from "../../Context/ContextApp";
import "./player.css";
export default function Player() {
  const { song, handleSelectSong } = useContext(Songs);
  const handleNextSong = () => {
    handleSelectSong(song.id + 1);
  };
  const handlePrevSong = () => {
    handleSelectSong(song.id - 1);
  };
  return (
    <div className="h-[100px] relative">
      <AudioPlayer
        className="bg-gray-900 h-[100px] text-white sticky bottom-0"
        src={song.url}
        layout="stacked-reverse"
        showSkipControls={true}
        showJumpControls={false}
        onClickPrevious={handlePrevSong}
        onClickNext={handleNextSong}
        onEnded={handleNextSong}
      />
    </div>
  );
}
